import Cookies from "js-cookie";

export const LEAD_ID_COOKIE = "fl_lead_id";
export const LEAD_ID_PARAM = "l";

const LEAD_ID_MAX_AGE_DAYS = 30;

function getLeadCookieOptions() {
  const isSecure = typeof window !== "undefined" && window.location.protocol === "https:";
  const hostname = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
  const options = {
    expires: LEAD_ID_MAX_AGE_DAYS,
    secure: isSecure,
    sameSite: "lax",
    path: "/",
  };
  if (hostname === "fractolabs.com" || hostname.endsWith(".fractolabs.com")) {
    options.domain = ".fractolabs.com";
  }
  return options;
}

export function getLeadIdFromSearch(search = "") {
  const normalized = search.startsWith("?") ? search.slice(1) : search;
  const value = new URLSearchParams(normalized).get(LEAD_ID_PARAM)?.trim();
  return value || null;
}

export function getStoredLeadId() {
  return Cookies.get(LEAD_ID_COOKIE)?.trim() || null;
}

/** URL param wins; if present — persist to cookie and return lead id. */
export function syncLeadIdFromSearch(search = "") {
  const fromUrl = getLeadIdFromSearch(search);
  if (fromUrl) {
    Cookies.set(LEAD_ID_COOKIE, fromUrl, getLeadCookieOptions());
    return fromUrl;
  }
  return getStoredLeadId();
}
